import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/MP_PracticeGame";
import Calculator from "../../components/MultCalculator";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useRatingQuestions from "../../hooks/useRatingQuestions";
import { MultiHook } from "tapable";

function GenerateUniqueRandom(min, max, notthisArray) {
    var returnMe = Math.floor(Math.random() * (max - min) + min);
    console.log(notthisArray)

    if (notthisArray.includes(returnMe)) {
        return GenerateUniqueRandom(min, max, notthisArray);
    }

    return returnMe;
}

function GenerateRandom(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
}

function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
}

function getAnswer(calculation) {
    const calculationParts = calculation;

    if (calculationParts.length === 3) {
        const [number1, operator, number2] = calculationParts;

        switch (operator) {
            case "÷":
                return number1 / number2;
            case "x":
                return number1 * number2;
            default:
                break;
        }
    } else if (calculationParts.length === 5) {
        let number1 = calculationParts[0];
        let number2 = calculationParts[2];
        let number3 = calculationParts[4];
        return number1 * number2 * number3;
    } else {
        return 0;
    }
}

function getWrongAnswer(correctAnswer, existingWrongAnswers) {
    var addOrSubtract = [0, 1];
    var output = 0;
    var getAnswer = true;

    do {
        var operatorSelection = Math.floor(Math.random() * addOrSubtract.length);
        var differenceSelection = Math.floor(Math.random() * 10);
        if (operatorSelection === 0) {
            output = correctAnswer - differenceSelection;
        } else {
            output = correctAnswer + differenceSelection;
        }

        if (
            existingWrongAnswers.includes(output) === false &&
            output !== correctAnswer &&
            output > 0
        ) {
            getAnswer = false;
        }
    } while (getAnswer === true);

    return output;
}

export default function Multiplayer({ ...props }) {
    console.log("timestables");
    const game = props.game;
    console.log(props);
    const { questions } = useRatingQuestions({ game_type: game.game_type }, game);
    const [correctQuestions, setCorrectQuestions] = useState([]);
    const [incorrectQuestions, setIncorrectQuestions] = useState([]);
    const [currentQuestion, setCurrentQuestion] = useState([,]);
    const [score, setScore] = useState(0);
    const [combo, setCombo] = useState(0);
    const [maxCombo, setMaxCombo] = useState(0);
    const [feedback, setFeedback] = useState([]);
    const [realQuestions, setRealQuestions] = useState();
    const [workAround, setWorkAround] = useState(false);
    const [place, setPlace] = useState(0);


    //this checks if correct and then goes to the next question
    async function checkResult(value, callback) {

        var isCorrect = true;
        if (value) {
            //correct answer
            if (parseInt(currentQuestion.answer) === parseInt(value)) {
                setCorrectQuestions([...correctQuestions, currentQuestion]);
                let multiplier = combo > 0 ? combo + 1 : 1;
                multiplier = multiplier > 5 ? 5 : multiplier;
                setScore(score + multiplier * 10);
                if (multiplier != 0 && multiplier != undefined)
                    props.SubmitScore(multiplier * 10);
                console.log("submit score")
                if (combo < 99) {
                    setCombo(combo + 1);
                }
                if (combo > maxCombo) {
                    setMaxCombo(combo);
                }
            } //incorrect answer
            else {
                isCorrect = false;
                setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
                if (combo === 0 && score >= 10) {
                    setScore((score - 10));
                    props.SubmitScore(-10);
                    console.log("submit score")
                } else {
                    setCombo(0);
                }

                let result = {
                    question: currentQuestion.calculation.join(" ") + " =",
                    correct: currentQuestion.answer,
                    incorrect: value
                };

                setFeedback([...feedback, result]);
            }

            if (callback) {
                await callback(isCorrect, currentQuestion.answer).then(() => {
                    setCurrentQuestion(
                        realQuestions[Math.floor(Math.random() * realQuestions.length)]
                    );
                });
            } else {
                setCurrentQuestion(
                    realQuestions[Math.floor(Math.random() * realQuestions.length)]
                );
            }
        }
    }

    //this method creates a list of players sorted by score
    function GetListOfPositions() {
        //order the scores
        console.log(props);
        //var web = props.parent.getwebrtc();
        var web = props.ReturnScores();
        var webcopy = JSON.parse(JSON.stringify(web));
        console.log(web);
        console.log(webcopy);
        //then order the scores in descending order
        //display them as a list
        webcopy.sort((a, b) => (a.score < b.score) ? 1 : -1)
        console.log(webcopy);
        //replace yourname with YOU
        for (let i = 0; i < webcopy.length; i++) {
            if (webcopy[i].username == props.details.username)
                webcopy[i].username = "You"
        }
        var scoreText = [];
        for (let i = 0; i < webcopy.length; i++) {
            let temptext = webcopy[i].username + ": " + webcopy[i].score
            scoreText.push(temptext);
        }
        console.log(scoreText);
        const listItems = scoreText.map((i) =>
            <li>{i}</li>
        );

        return listItems;
    }

    useEffect(() => {
        if (questions && questions.length > 0) {
            console.log(questions);
            if (realQuestions == null) {
                console.log("useeffect3")
                if (questions) {
                    var tempQuestions = [];

                    for (let i = 0; i < questions.length; i++) {
                        for (let x = 0; x < questions[i].length; x++) {
                            //makes 3 questions of each topic
                            for (let y = 0; y < 3; y++) {   
                                let override = "none";
                                console.log(questions.length);
                                console.log(questions[i].length);
                                let gcalc = questions[i][x];
                                console.log(gcalc);
                                let calc = gcalc.example_question.split(" ");
                                console.log("CALC");
                                console.log(calc);
                                //generation taken from practice mode
                                let generatedCalculation = [];
                                // check that the calculation is [number1 , operator, number2] (eg 1 x 2)
                                var randInt = Math.floor(Math.random() * 10 + 1);
                                if (calc.length === 3) {
                                    const number2 = parseInt(calc[2]);
                                    const number1 = calc[1] === "÷" ? randInt * number2 : randInt;
                                    generatedCalculation[0] = number1;
                                    generatedCalculation[1] = calc[1];
                                    generatedCalculation[2] = number2;
                                } else if (calc.length === 5) {
                                    // if got length of 5 then we expect [number1 , operator, number2, operator, number3] (eg. a x b x c) and need to generate a random number for each part of the calulation
                                    const number1 = Math.floor(Math.random() * 9 + 1);
                                    const number2 = Math.floor(Math.random() * 9 + 1);
                                    const number3 = Math.floor(Math.random() * 9 + 1);
                                    const operator = "x";

                                    generatedCalculation[0] = number1;
                                    generatedCalculation[1] = operator;
                                    generatedCalculation[2] = number2;
                                    generatedCalculation[3] = operator;
                                    generatedCalculation[4] = number3;
                                }

                                if (gcalc.topic_key == "multiple10") {//times by multiple of 10
                                    let num1 = GenerateRandom(1, 99);
                                    var num2array = [10, 100, 1000];
                                    var num2 = num2array[GenerateRandom(0, num2array.length)];
                                    const operator = "x";
                                    //
                                    generatedCalculation[0] = num1;
                                    generatedCalculation[1] = operator;
                                    generatedCalculation[2] = num2;
                                }
                                if (gcalc.topic_key == "multiple10+1") {//times by almost a multiple of 10
                                    let num1 = GenerateRandom(1, 99);
                                    var num2array = [9, 99, 999, 11, 101, 1001];
                                    var num2 = num2array[GenerateRandom(0, num2array.length)];
                                    const operator = "x";
                                    //
                                    generatedCalculation[0] = num1;
                                    generatedCalculation[1] = operator;
                                    generatedCalculation[2] = num2;
                                }
                                if (gcalc.topic_key == "dec") {//times by decimal
                                    //generate answer first and then work backwards
                                    var num2array = [10, 100, 1000];
                                    var num2 = num2array[GenerateRandom(0, num2array.length)];
                                    let ans = 0;
                                    if (num2 == 10) {
                                        ans = GenerateRandom(1, 10)
                                    }
                                    if (num2 == 100) {
                                        ans = GenerateRandom(11, 100)
                                    }
                                    if (num2 == 1000) {
                                        ans = GenerateRandom(101, 1000)
                                    }
                                    let num1 = ans / num2;
                                    const operator = "x";
                                    //
                                    generatedCalculation[0] = num1;
                                    generatedCalculation[1] = operator;
                                    generatedCalculation[2] = num2;
                                }

                                if (gcalc.topic_key == "cubes") {//cube a number
                                    override = "cubes";
                                    var num1 = GenerateRandom(1, 10);
                                    const operator = "^";
                                    //
                                    generatedCalculation[0] = num1;
                                    generatedCalculation[1] = "³";
                                    var ans = num1 * num1 * num1;
                                }
                                if (gcalc.topic_key == "multorder"){//multiplication order
                                    override = "multorder";
                                    var num1 = GenerateRandom(1,10);
                                    var num2 = GenerateRandom(2,10);
                                    var num3 = GenerateRandom(1,num2);
                                    //
                                    generatedCalculation[0] = num1;
                                    generatedCalculation[1] = "*";
                                    generatedCalculation[2] = "(";
                                    generatedCalculation[3] = num2;
                                    generatedCalculation[4] = "-";
                                    generatedCalculation[5] = num3;
                                    generatedCalculation[6] = ")";
                                    var ans = num1*(num2-num3);
                                }
                                if (gcalc.topic_key == "divorder"){//multiplication order
                                    override = "divorder";
                                    var ans = GenerateRandom(1,10);
                                    var num1 = GenerateRandom(2,10);
                                    var num2 = GenerateRandom(1,num1);
                                    var num3 = ans * (num1 - num2);
                                    //
                                    generatedCalculation[0] = num3;
                                    generatedCalculation[1] = "÷";
                                    generatedCalculation[2] = "(";
                                    generatedCalculation[3] = num1;
                                    generatedCalculation[4] = "-";
                                    generatedCalculation[5] = num2;
                                    generatedCalculation[6] = ")";
                                }
                                if (gcalc.topic_key == "squares"){//cube a number
                                    override = "squares";
                                    var num1 = GenerateRandom(1,10);
                                    const operator = "^";
                                    //
                                    generatedCalculation[0] = num1;
                                    generatedCalculation[1] = "²";
                                    var ans = num1*num1;
                                }
                                if (gcalc.topic_key == "squares2"){//cube a number
                                    console.log("I'm a squares2 question");
                                    override = "squares2";
                                    var num1 = GenerateRandom(1,10);
                                    var num2 = GenerateRandom(1,9);
                                    var ans = (num1*num1) + num2;
                                    //
                                    generatedCalculation[0] = num1;
                                    generatedCalculation[1] = "²";
                                    generatedCalculation[2] = "+";
                                    generatedCalculation[3] = num2;
                                    
                                }
                                if (gcalc.topic_key == "div"){//cube a number
                                    override = "div";
                                    var num1 = GenerateRandom(1,10);
                                    var num2 = GenerateRandom(1,10)*num1*10;
                                    var ans = num2/num1;
                                    //
                                    generatedCalculation[0] = num2;
                                    generatedCalculation[1] = "÷";
                                    generatedCalculation[2] = num1;
                                }
                                 //new questions here
                    if(gcalc.topic_key == "count2")
                    {
                        override = "count2";
                        var extraNumbers = "";
                        var num1array = [2,4,6,8,10,12,14,16];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (let y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 2;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 2s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(gcalc.topic_key == "count3")
                    {
                        override = "count3";
                        var extraNumbers = "";
                        var num1array = [3,6,9,12,15,18,21,24];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (let y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 3;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 3s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(gcalc.topic_key == "count4")
                    {
                        override = "count4";
                        var extraNumbers = "";
                        var num1array = [4,8,12,16,20,24,28,32];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (let y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 4;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 4s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(gcalc.topic_key == "count5")
                    {
                        override = "count5";
                        var extraNumbers = "";
                        var num1array = [5,10,15,20,25,30,35,40];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (let y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 5;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 5s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(gcalc.topic_key == "count6")
                    {
                        override = "count6";
                        var extraNumbers = "";
                        var num1array = [6,12,18,24,30,36,42,48];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (let y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 6;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 6s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(gcalc.topic_key == "count7")
                    {
                        override = "count7";
                        var extraNumbers = "";
                        var num1array = [7,14,21,28,35,42,49,56];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (let y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 7;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 7s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(gcalc.topic_key == "count8")
                    {
                        override = "count8";
                        var extraNumbers = "";
                        var num1array = [8,16,24,32,40,48,56,64];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (let y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 8;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 8s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(gcalc.topic_key == "count9")
                    {
                        override = "count9";
                        var extraNumbers = "";
                        var num1array = [9,18,27,34,45,54,63,72];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (let y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 9;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 9s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                    }
                    if(gcalc.topic_key == "count10")
                    {
                        override = "count10";
                        var extraNumbers = "";
                        var num1array = [10,20,30,40,50,60,70,80];
                        var num1 = num1array[GenerateRandom(0, num1array.length)];

                        for (let y = 0; y < 3; y++)
                        {
                            extraNumbers += num1 + ", ";
                            num1 += 9;
                        }

                        var ans = num1;

                        generatedCalculation[0] = "Counting in 10s, what is next in the sequence? ";
                        generatedCalculation[1] = extraNumbers;
                        generatedCalculation[2] = "?";
                        console.log(gcalc);
                    }
                                console.log(generatedCalculation);
                                console.log("OVERIDE: " + override);

                                if (override == "none") {
                                    console.log("I SHOULD BE GENERATING AN ANSWER");
                                    console.log(generatedCalculation);
                                    var questionObj = {
                                        calculation: generatedCalculation,
                                        answer: getAnswer(generatedCalculation),
                                        topic_id: gcalc.topic_id
                                        //question: questionText,
                                        //answers: questionAnswers,
                                        //questionLine2: questionLine2,
                                        //subject: qsSubject
                                    };
                                    console.log(questionObj);
                                }else {
                                    var questionObj = {
                                        calculation: generatedCalculation,
                                        answer: ans,
                                        topic_id: gcalc.topic_id
                                        //question: questionText,
                                        //answers: questionAnswers,
                                        //questionLine2: questionLine2,
                                        //subject: qsSubject
                                    };
                                }
                                console.log(questionObj);
                                tempQuestions.push(questionObj)
                            }

                        }

                    }
                    console.log(tempQuestions);
                    setRealQuestions(tempQuestions);
                    setCurrentQuestion(tempQuestions[0]);
                    console.log(tempQuestions[0])
                }
            }
        }
        console.log(questions);
        console.log(currentQuestion);
    }, [questions]);

    //this gets the position of the player, 1st, 2nd etc.
    function GetPlace() {
        var position = 0;
        //order the scores
        var web = props.ReturnScores();
        var webcopy = JSON.parse(JSON.stringify(web));
        //then order the scores in descending order
        //display them as a list
        webcopy.sort((a, b) => (a.score < b.score) ? 1 : -1)
        console.log(webcopy);
        //gets your position in the list
        for (let i = 0; i < webcopy.length; i++) {
            if (webcopy[i].username == props.details.username) {
                setPlace(i + 1);
                position = i + 1;
            }

        }
        console.log(place);
        console.log(position);
        return position;
    }

    console.log(currentQuestion.calculation + "and " + currentQuestion.answer);

    function ComboImage(){
        console.log(props);
        let comboNum = combo;
        if (combo > 4)
            comboNum = 4;
        var imageName = props.game.animation_path + "/combo"+comboNum+".gif";
         //return <img src= {{imageName}} style={{position:"relative"}}></img>
         return <img style={{position: "absolute",top:"40%",right:"6%"}} src={require("../../assets/"+imageName)}></img>
    }

    return (
        <PracticeGame
            parent={props}
            loading={!questions}
            correct={correctQuestions}
            incorrect={incorrectQuestions}
            score={score}
            onBack={() => props.onBack()}
            defaultTimer={60}
            restart={() => {
                setCombo(0);
                setScore(0);
                setCorrectQuestions([]);
                setIncorrectQuestions([]);
            }}
            feedback={feedback}
            homework_id={props.homework_id}
            getplace={() => GetPlace()}
        >
            <Body>
                <FormContent style={{ right: "100px", position: "relative", top: "0px", width: "200px", height: "50%" }}>
                    <br></br>
                    {GetListOfPositions()}
                </FormContent>
                {
                    currentQuestion ?
                        <Calculator

                            currentQuestion={[currentQuestion.calculation, currentQuestion.answer]}
                            onSubmitted={checkResult}
                        /> : null
                }
                <Combo>
                    <span style={{ fontSize: "50px" }}>{combo}</span>
                    <span style={{ fontSize: "20px" }}>COMBO</span>
                </Combo>
            </Body>
            {ComboImage()}
        </PracticeGame>
    );
}

const Body = styled.div`
    width: 100%;
    height: 100%;
    background-image: url(${background});
    background-size: cover;
    background-position: 0px -1px;
    display: flex;
    justify-content: center;
    padding-top: 40px;
`;

const Result = styled.div`
    width: 100%;
    height: 100%;
    font-size: 5em;
    text-align: center;
    border: solid 2px #683d8c;
`;

const Combo = styled.div`
    background: #4391bb;
    width: 120px;
    height: 120px;
    border-radius: 75px;
    border: solid #204b7b 4px;
    display: flex;
    flex-direction: column;
    text-align: center;
    color: #fff;
    justify-content: center;
    font-weight: 600;
`;

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border: 2px solid #673b8b;
  border-radius: 1em;
  font-size: 2em;

  h1 {
    color: #673b8b;
    font-size: 4em;
    margin: 0.25em;
  }


`;
